
// Converte la VAPID key da base64url a Uint8Array (richiesto da PushManager.subscribe)
function urlBase64ToUint8Array(base64String)
{
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

// Restituisce il service worker attivo.
// Gestisce i casi: active (fast), installing/waiting (attende attivazione), assente (attende ready).
async function swReady(timeoutMs = 15000)
{
  const existing = await navigator.serviceWorker.getRegistration('/');

  if (existing?.active) return existing;

  // SW in fase di install/waiting: aspetta che diventi active
  if (existing && (existing.installing || existing.waiting)) {
    const sw = existing.installing || existing.waiting;
    await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Service worker non si è attivato in tempo.')), timeoutMs);
      sw.addEventListener('statechange', function handler(e) {
        if (e.target.state === 'activated') {
          clearTimeout(timer);
          sw.removeEventListener('statechange', handler);
          resolve();
        } else if (e.target.state === 'redundant') {
          clearTimeout(timer);
          sw.removeEventListener('statechange', handler);
          reject(new Error('Service worker rimosso prima di attivarsi.'));
        }
      });
    });
    return existing;
  }

  return Promise.race([
    navigator.serviceWorker.ready,
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Service worker non disponibile o non ancora attivo. Riprova tra qualche secondo.')), timeoutMs)
    ),
  ]);
}

async function getNotificationSubscriptions() {
  const registration = await swReady();
  return await registration.pushManager.getSubscription();
}

export {
  urlBase64ToUint8Array,
  swReady,
  getNotificationSubscriptions
}
